import { TABLE_CONSTANTS, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { GeneralTable } from "@/shared/components/ui";
import { Box, Button, Card, CardContent, Grid, Typography } from "@mui/material";
import { useFetchReporteGeneral } from "@/shared/actions/erp";
import { ReporteVenta } from "@/shared/interfaces";
import { useTableColumnsReporteGeneralEVA } from "@/shared/hooks/useTableColumnsReporteGeneralEVA";
import { useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import 'dayjs/locale/es';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { FilterAltOff, Search } from "@mui/icons-material";


export default function TableReporteVentaEVA() {

  // Estados para el rango de fechas (por defecto últimos 30 días)
  const [fechaDesde, setFechaDesde] = useState<Dayjs | null>(
    null
  );
  const [fechaHasta, setFechaHasta] = useState<Dayjs | null>(null);

  const {
    pagination: paginationReporteGeneralEVA,
    setPagination: setPaginationReporteGeneralEVA,
    vendedor: vendedorReporteGeneralEVA,
  } = useTableFilter();

  const {
    filterObject: filterObjectReporteGeneralEVA,
    columnFilters: columnFiltersReporteGeneralEVA,
    setColumnFilters: setColumnFiltersReporteGeneralEVA
  } = useTableServerSideFiltering();

  const {
    pageIndex: pageIndexReporteGeneralEVA,
    pageSize: pageSizeReporteGeneralEVA
  } = paginationReporteGeneralEVA;

  const {
    refetch: refetchReporteGeneralEVA,
    data: dataReporteGeneralEVA,
    isLoading: isLoadingReporteGeneralEVA,
    isRefetching: isRefetchingReporteGeneralEVA
  } = useFetchReporteGeneral({
      page: pageIndexReporteGeneralEVA + 1,
      fecha_inicio_prospecto: fechaDesde?.format('YYYY-MM-DD'),
      fecha_fin_prospecto: fechaHasta?.format('YYYY-MM-DD'),
      page_size: pageSizeReporteGeneralEVA,
      user_create: vendedorReporteGeneralEVA,
      ...filterObjectReporteGeneralEVA,
      filterByState: false
    },
  )

  const { columnBase: columnBaseReporteGeneralEVA } = useTableColumnsReporteGeneralEVA()

  const handleFiltrar = () => {
    // Maquetación - lógica de filtrado
    if(fechaDesde && fechaHasta){
      refetchReporteGeneralEVA();
    }
  };

  const handleLimpiar = () => {
    setFechaDesde(null);
    setFechaHasta(null);
    refetchReporteGeneralEVA();
  };

  return (
    <Grid
      container
      spacing={2}
    >

      {/*Rango de fechas*/}
      <Grid item xs={12} sx={{
      }}>
        <Card sx={{
          width: '100%',
          padding: 1
        }}>

          <Typography variant="subtitle2" style={{ fontWeight: 'bold' }} mb={1.5}>
            Filtro de rango de fechas
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                flexWrap: 'wrap',
              }}
            >
              <DatePicker
                label="Desde"
                value={fechaDesde}
                onChange={(newValue) => setFechaDesde(newValue)}
                format="DD/MM/YYYY"
                maxDate={fechaHasta}
                slotProps={{ textField: { size: 'small' } }}
                sx={{ width: { xs: '100%', sm: 160 } }}
              />
              <DatePicker
                label="Hasta"
                minDate={fechaDesde}
                value={fechaHasta}
                onChange={(newValue) => setFechaHasta(newValue)}
                format="DD/MM/YYYY"
                slotProps={{ textField: { size: 'small' } }}
                sx={{ width: { xs: '100%', sm: 160 } }}
              />
              <Button
                variant="contained"
                color="primary"
                startIcon={<Search />}
                onClick={handleFiltrar}
              >
                Buscar
              </Button>
              <Button
                variant="outlined"
                startIcon={<FilterAltOff />}
                onClick={handleLimpiar}
              >
                Limpiar
              </Button>
            </Box>
          </LocalizationProvider>
        </Card>
      </Grid>


      <Grid item xs={12}>
        <GeneralTable<ReporteVenta>
          columns={columnBaseReporteGeneralEVA}
          data={dataReporteGeneralEVA?.data.data || []}
          //
          isLoading={isLoadingReporteGeneralEVA}
          isRefetching={isRefetchingReporteGeneralEVA}
          ///* search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          ///* pagination
          pagination={paginationReporteGeneralEVA}
          onPaging={setPaginationReporteGeneralEVA}
          rowCount={dataReporteGeneralEVA?.data?.count}
          ///* filters - server side
          enableManualFiltering={true}
          columnFilters={columnFiltersReporteGeneralEVA}
          onColumnFiltersChange={setColumnFiltersReporteGeneralEVA}
          enableSorting={false}

          // crud
          canEdit={false}
          enableEditing={false}
          showCustomActionBtnSpace={false}
          actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_SMALL}
        />
      </Grid>

    </Grid>
  )

}
